module.exports = __webpack_public_path__ + "nebular.25116a35e5d6e6e2e4fa.ttf";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/src/app/@nebular/icons/fonts/nebular.ttf?jaecku
// module id = ../../../../../src/app/@nebular/icons/fonts/nebular.ttf?jaecku
// module chunks = styles